import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LoginRequest } from '~client/model/login-request';
import { UserLoginResponse } from '~client/model/user-login-response';
import { rxTask } from '~common/helper/mobx-tasks';
import { apiClient } from '~web/client';
import { Config } from '~web/config';
import { stores } from '~web/store';
import { AuthStore } from '~web/store/auth-store';

export const authenticate = (response: UserLoginResponse): void => {
  const { authToken } = response;
  const authStore = stores.authStore as AuthStore;
  // in debug mode we proxy the API so we use the header for auth to avoid CORS errors
  if (Config.isDebugBuild) {
    apiClient.setAuthorization(authToken);
  }
  authStore.login(authToken);
};

export const performLogin = (request: LoginRequest): Observable<UserLoginResponse> =>
  apiClient.userLoginController.login$(request);

export const login = rxTask((emailAddress: string, password: string) =>
  performLogin({ emailAddress, password }).pipe(tap(authenticate)),
);



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/web/src/js/interactor/user-login/perform-login.ts